import { useContext, useEffect, useState } from 'react';
import '../../css/TextViewer.scss';
import apiUrl from '../../assets/apiUrl';
import FormData from 'form-data';
import AuthContext, { getAccessToken } from '../Auth';

interface Props {
    fileUrl: string;
    fileName: string;
    fileUid: string;
}

const supportedFormats = ['txt', 'md', 'html', 'json'];

const DocumentViewer: React.FC<Props> = ({ fileUrl, fileName, fileUid }) => {
    const [content, setContent] = useState('');
    const [currentContent, setCurrentContent] = useState('');
    const { fetchWrapper } = useContext(AuthContext);
    useEffect(() => {
        fetchWrapper(fileUrl).then(async (res) => {
            const text = await res.text();
            setContent(text);
            setCurrentContent(text);
        });
    }, [fileUrl, fetchWrapper]);
    const save = async () => {
        const token = await getAccessToken();
        const formData: any = new FormData();
        formData.append('file', new Blob([currentContent]));
        await fetchWrapper(`${apiUrl}/file/${fileUid}`, {
            method: 'PUT',
            body: formData,
            headers: { 'x-access-token': token },
        });
        setContent(currentContent);
    };
    return (
        <div className="container">
            <div className="editor">
                <div className="head">
                    <h2>
                        {fileName} {currentContent !== content && '*'}
                    </h2>
                    <button onClick={save}>save</button>
                </div>
                <div
                    className="content-body"
                    spellCheck={false}
                    contentEditable={true}
                    onInput={(e: any) =>
                        setCurrentContent(e.target.textContent)
                    }
                >
                    {content}
                </div>
            </div>
        </div>
    );
};

export default DocumentViewer;
export { supportedFormats };
